import { render } from "./ListeCategorieInfo.vue?vue&type=template&id=6a368734&ts=true"
import script from "./ListeCategorieInfo.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__